<template>
  <main>
    <div class="screen stops">
      <div class="from">van</div>
      <ul>
        <li v-for="stop in stops" :key="stop.uid" :class="stop.riverside" @click="handleRowClick(stop)">
          {{ stop.name }}
        </li>
      </ul>
    </div>
  </main>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      stops: state => state.stops
    })
  },
  methods: {
    handleRowClick (stop) {
      this.$router.push(`/stops/${stop.name}`)
    }
  },
  created() {
    this.$store.commit('SET_BACK_BUTTON', false)
  }
}
</script>

<style lang="scss" scoped>
.stops {
  float: left;
  width: 100%;
  padding-bottom: 30px;
}

.from {
  margin-bottom: 15px;
  font-size: 15px;
  color: #fff;
  letter-spacing: 0.58px;
  text-align: center;
}

ul {
  float: left;
  width: 100%;
  list-style: none;
  padding: 0 30px 44px;
  margin: 0;
}

ul li {
  position: relative;
  float: left;
  width: 100%;
  margin-bottom: 10px;
  padding: 10px 0;
  background: #70CCFF;
  text-align: center;
  font-weight: 500;
  font-size: 18px;
  letter-spacing: 0.5px;
  line-height: 25px;
  color: #fff;
  border-radius: 5px;

  &.noord {
    &::after {
      content: 'N';
      position: absolute;
      right: 20px;
      top: 11px;
      font-size: 14px;
    }
  }
}

ul li:nth-child(even) {
  margin-bottom: 10px;
}
</style>
